import debug from 'debug';

import { isDev } from '~/dev/utils/isDev';

if (isDev && typeof window !== 'undefined' && !localStorage.debug) {
  debug.enable('app:*');
}

export const logger = {
  utils: debug('app:utils'),
  hooks: debug('app:hooks'),
  api: debug('app:api'),
  auth: debug('app:auth'),
  storage: debug('app:storage'),
  encryption: debug('app:encryption'),
  mockService: debug('app:mockService'),
};
